export const MoneyReciveIcon = ({
  strokeColor = "var(--color-btn-primary-active)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g id="vuesax/linear/money-recive">
      <g id="Group">
        <path
          id="Vector"
          d="M6.3335 9.16682C6.3335 9.81349 6.83351 10.3335 7.44684 10.3335H8.70015C9.23349 10.3335 9.66683 9.88015 9.66683 9.31349C9.66683 8.70682 9.40017 8.48682 9.00684 8.34682L7.00016 7.64682C6.60683 7.50682 6.34017 7.29349 6.34017 6.68016C6.34017 6.12016 6.77349 5.66016 7.30682 5.66016H8.56016C9.17349 5.66016 9.6735 6.18016 9.6735 6.82682"
          stroke="var(--color-blue)"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M8 5V11"
          stroke="var(--color-blue)"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        id="Vector_3"
        d="M14.6668 8.00065C14.6668 11.6807 11.6802 14.6673 8.00016 14.6673C4.32016 14.6673 1.3335 11.6807 1.3335 8.00065C1.3335 4.32065 4.32016 1.33398 8.00016 1.33398"
        stroke="var(--color-blue)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M11.3335 2V4.66667H14.0002"
        stroke="var(--color-blue)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M14.6668 1.33398L11.3335 4.66732"
        stroke="var(--color-blue)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
